import { Component, OnInit } from '@angular/core';
import { BasicNotificationElementComponent } from '../basic-notification-element/basic-notification-element.component';

@Component( {
    selector: 'ridango-basic-information-notification-v2',
    templateUrl: './basic-information-notification-v2.component.html',
    styleUrls: [ './basic-information-notification-v2.component.scss' ]
} )
export class BasicInformationNotificationV2Component extends BasicNotificationElementComponent implements OnInit {

    constructor() {
        super();
    }
    ngOnInit () {

        // tslint:disable-next-line:max-line-length
        this.title = this.notification.title ? this.notification.title : 'information-v2';
        if ( this.notification.title ) {
            this.title = this.notification.title;
        }
        this.message = this.notification.message;
    }


}
